import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const { sentryDsn, sentryEnvironment } = useRuntimeConfig().public;

  // Skip init if no DSN is configured (e.g. local dev without .env)
  if (!sentryDsn) return;

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentryDsn as string,
    environment: (sentryEnvironment as string) || 'development',

    tracesSampleRate: 0.01, // 1% of transactions — adjust to your needs

    // Vue-specific options
    attachProps: true,  // Attach Vue component props to error events
    logErrors: true,    // Also call Vue's original logError (keeps console errors visible)

    integrations: [
      // Tracks page navigations and outgoing HTTP requests as performance transactions
      Sentry.browserTracingIntegration(),
    ],
  });
});
